// Constants for useAuthorization
// HttpOnly cookie. Session cookie. SameSite cookie. Http only
export const COOKIE_SESSION_EXPIRES_KEY = 'session_expires';
// Constants for interval functions
export const TIME_RANGE = 3000; // 3 sec
export const EXTERNAL_POPUP_TIMEOUT = 500; // 500 milliseconds
export const SESSION_EXPIRY_MULTIPLY = 60000; // 1 min -> 60000 milliseconds
export const EXPIRED_SESSION_TIMESTAMP = new Date('1970-01-01').getTime();
